import React, { useState } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import dhofarLogo from "../../assets/images/Logo.png";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { setLanguage } from "../../Redux/LoadingRedux";

const ukFlagIcon =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
      <clipPath id="circleClip">
        <circle cx="30" cy="30" r="30" />
      </clipPath>
      <g clip-path="url(#circleClip)">
        <rect width="60" height="60" fill="#012169"/>
        <path d="M0 0 L60 60 M60 0 L0 60" stroke="#FFFFFF" stroke-width="12"/>
        <path d="M0 0 L60 60 M60 0 L0 60" stroke="#C8102E" stroke-width="6"/>
        <path d="M30 0 V60 M0 30 H60" stroke="#FFFFFF" stroke-width="18"/>
        <path d="M30 0 V60 M0 30 H60" stroke="#C8102E" stroke-width="10"/>
      </g>
    </svg>
  `);

const omanFlagIcon =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
      <defs>
        <clipPath id="omanCircleClip">
          <circle cx="30" cy="30" r="30" />
        </clipPath>
      </defs>
      <g clip-path="url(#omanCircleClip)">
        <rect width="60" height="60" fill="#ffffff"/>
        <rect x="18" y="0" width="42" height="20" fill="#ffffff"/>
        <rect x="18" y="20" width="42" height="20" fill="#d71920"/>
        <rect x="18" y="40" width="42" height="20" fill="#007a3d"/>
        <rect x="0" y="0" width="18" height="60" fill="#d71920"/>
      </g>
    </svg>
  `);

const languageOptions = [
  { code: "en", label: "English", flagSrc: ukFlagIcon, flagAlt: "UK flag" },
  { code: "ar", label: "العربية", flagSrc: omanFlagIcon, flagAlt: "Oman flag" },
];

function TopNavBar() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  const { selectedLanguage } = useSelector((state) => state.loading);
  const [anchorEl, setAnchorEl] = useState(null);

  const currentLanguage =
    selectedLanguage || (i18n.language?.startsWith("ar") ? "ar" : "en");

  const activeLanguage =
    languageOptions.find((option) => option.code === currentLanguage) ||
    languageOptions[0];

  const isMenuOpen = Boolean(anchorEl);

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (languageCode) => {
    if (languageCode === currentLanguage) {
      handleCloseMenu();
      return;
    }

    dispatch(setLanguage(languageCode)).then(() => {
      i18n.changeLanguage(languageCode);
      handleCloseMenu();
    });
  };

  return (
    <div className="mb-3 bg-white">
      <AppBar
        sx={{
          backgroundColor: "white",
          height: "100px",
          boxShadow: 1,
          zIndex: 0,
          position: "sticky",
        }}
      >
        <Toolbar
          sx={{
            minHeight: "100px",
            display: "flex",
            justifyContent: "space-between",
            gap: 2,
            px: { xs: 1, sm: 2 },
          }}
        >
          <Box
            component="button"
            type="button"
            onClick={() => navigate("/")}
            sx={{
              display: "flex",
              alignItems: "center",
              px: 0,
              border: "none",
              background: "transparent",
              cursor: "pointer",
            }}
          >
            <div className="container-fluid">
              <img
                src={dhofarLogo}
                alt="Brand logo"
                style={{ width: "220px", maxWidth: "100%" }}
              />
            </div>
          </Box>

            {/* <Box>
            <Box
              component="button"
              type="button"
              onClick={handleOpenMenu}
              aria-haspopup="menu"
              aria-expanded={isMenuOpen ? "true" : undefined}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.25,
                minWidth: { xs: "112px", sm: "140px" },
                border: "1px solid #d9d9df",
                borderRadius: "999px",
                backgroundColor: "#ffffff",
                color: "#1f2430",
                boxShadow: "0 8px 24px rgba(18, 22, 33, 0.08)",
                px: { xs: 1, sm: 1 },
                py: 0.4,
                cursor: "pointer",
              }}
            >
              <Box
                component="img"
                src={activeLanguage.flagSrc}
                alt={activeLanguage.flagAlt}
                sx={{
                  width: 26,
                  height: 26,
                  borderRadius: "50%",
                  objectFit: "cover",
                  boxShadow: "0 0 0 1px rgba(0, 0, 0, 0.08)",
                  backgroundColor: "#ffffff",
                }}
              />
              <Typography
                sx={{
                  flex: 1,
                  fontSize: { xs: "0.7rem", sm: "0.8rem" },
                  fontWeight: 600,
                  textAlign: "left",
                }}
              >
                {activeLanguage.label}
              </Typography>
              <KeyboardArrowDownIcon
                sx={{
                  transform: isMenuOpen ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.2s ease",
                }}
              />
            </Box>

            <Menu
              anchorEl={anchorEl}
              open={isMenuOpen}
              onClose={handleCloseMenu}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              PaperProps={{
                sx: {
                  mt: 1,
                  minWidth: { xs: 170, sm: 220 },
                  borderRadius: "20px",
                  p: 1,
                  boxShadow: "0 18px 45px rgba(12, 18, 33, 0.14)",
                },
              }}
            >
              {languageOptions.map((option) => {
                const isActive = option.code === currentLanguage;

                return (
                  <MenuItem
                    key={option.code}
                    onClick={() => handleLanguageChange(option.code)}
                    sx={{
                      borderRadius: "14px",
                      display: "flex",
                      alignItems: "center",
                      gap: 1.25,
                      py: 1.1,
                      px: 1.2,
                      mb: 0.5,
                      backgroundColor: isActive ? "#f5f7fb" : "transparent",
                    }}
                  >
                    <Box
                      component="img"
                      src={option.flagSrc}
                      alt={option.flagAlt}
                      sx={{
                        width: 28,
                        height: 28,
                        borderRadius: "50%",
                        objectFit: "cover",
                        boxShadow: "0 0 0 1px rgba(0, 0, 0, 0.08)",
                        backgroundColor: "#ffffff",
                      }}
                    />
                    <Typography sx={{ fontSize: "1rem", fontWeight: 500 }}>
                      {option.label}
                    </Typography>
                  </MenuItem>
                );
              })}
            </Menu>
          </Box> */}
        </Toolbar>
      </AppBar>
    </div>
  );
}

export default TopNavBar;
